import ApiService from "@/api/api.service.js"
import auth from "@/authConfig"

export async function fetchConditionsNeedingAttention() {
  const tokenResponse = await auth.acquireTokenResponse()
  const authToken = tokenResponse?.accessToken || ""
  const azureId = localStorage.getItem("azure_id") || ""

  const resp = await ApiService.GetConditionsNeedingAttention(azureId, authToken)
  const data = resp?.data?.data || []

  return {
    azureId,
    authToken,
    allData: (data || []).map(normalizeRow)
  }
}

function buildBorrowerName(x) {
  const last = x.borrowerLastName || ""
  const first = x.borrowerFirstName || ""
  if (!last && !first) return ""
  if (last && first) return `${last}, ${first}`
  return last || first
}

function shortDateTime(v) {
  if (!v) return ""
  const d = new Date(v)
  const mm = String(d.getMonth() + 1).padStart(2, "0")
  const dd = String(d.getDate()).padStart(2, "0")
  const yyyy = d.getFullYear()
  const hh = d.getHours() % 12 || 12
  const mi = String(d.getMinutes()).padStart(2, "0")
  const ap = d.getHours() >= 12 ? "PM" : "AM"
  return `${mm}/${dd}/${yyyy} ${hh}:${mi} ${ap}`
}

function normalizeRow(x) {
  const parts = [x.propertyAddress, x.propertyCity, x.propertyState, x.propertyZip].filter(Boolean)
  return {
    ...x,
    attentionSetAt: shortDateTime(x.attentionSetAt),
    borrowerName: buildBorrowerName(x),
    fullPropertyAddress: parts.join(", ")
  }
}
